import React, { createContext, useContext, useReducer } from "react";

const initialState = {
  massId: null,
  topic: null,
  genre: null,
  markingScheme: null,
  groups: [],
};

/* ---------- reducer & actions ---------- */
function reducer(state, action) {
  switch (action.type) {
    case "SET_MASS_ID":
      return { ...state, massId: action.massId };
    case "SET_TOPIC":
      return { ...state, topic: action.topic };
    case "SET_GENRE":
      return { ...state, genre: action.genre };
    case "SET_MARKING_SCHEME":
      return { ...state, markingScheme: action.markingScheme };
    case "ADD_GROUP":
      return {
        ...state,
        groups: [
          ...state.groups,
          {
            id: action.id,
            files: action.files,
            status: action.status,
            text: action.text,
            type: action.type,
            inputType: action.inputType,
          },
        ],
      };
    case "UPDATE_STATUS":
      return {
        ...state,
        groups: state.groups.map((g) =>
          g.id === action.id
            ? {
                ...g,
                status: action.status,
              }
            : g
        ),
      };

    case "SET_TEXT":
      return {
        ...state,
        groups: state.groups.map((g) =>
          g.id === action.id
            ? { ...g, text: action.text, status: "completed" }
            : g
        ),
      };

    case "SET_ERROR":
      return {
        ...state,
        groups: state.groups.map((g) =>
          g.id === action.id
            ? { ...g, status: "error", error: action.error }
            : g
        ),
      };
    case "DELETE_GROUP":
      return {
        ...state,
        groups: state.groups.filter((g) => g.id !== action.id),
      };
    case "RESET":
      return {
        ...state,
        massId: null,
        topic: null,
        genre: null,
        markingScheme: null,
        groups: [],
      };
    default:
      return state;
  }
}

const BulkOCRContext = createContext(null);

export function BulkOCRProvider({ children }) {
  const [state, dispatch] = useReducer(reducer, initialState);
  return (
    <BulkOCRContext.Provider value={{ state, dispatch }}>
      {children}
    </BulkOCRContext.Provider>
  );
}

export function useBulkOCR() {
  const ctx = useContext(BulkOCRContext);
  if (!ctx) throw new Error("useBulkOCR must be used inside BulkOCRProvider");
  return ctx;
}
